import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'gm-not-found-page',
    imports: [],
    templateUrl: './not-found-page.component.html',
    styleUrl: './not-found-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {

  constructor() {
    //setTimeout(() => this.animateFalling(), 1000);
  }

  /*private animateFalling() {
    // Query all elements on the screen
    const elements = document.querySelectorAll('*');
    const positions: any[] = [];

    // First loop: calculate positions
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const left = rect.left + window.scrollX;
      positions.push({ element, top, left });
    });

    // Second loop: set positions and animate
    positions.forEach(({ element, top, left }) => {
      // Set fixed position to the element
      element.style.position = 'fixed';
      element.style.top = `${top}px`;
      element.style.left = `${left}px`;

      // Animate the element to fall to the bottom of the screen with a random delay
      const delay = Math.random() * 2000; // Random delay between 0 and 2 seconds
      setTimeout(() => {
        element.style.transition = 'top 2s ease-in';
        element.style.top = `${window.innerHeight}px`;
      }, delay);
    });
  }*/
}
